import { FC } from "react";

import { useCurrentWorkspaceContext } from "@/domain/workspace/hooks/useCurrentWorkspaceContext";

import { ClimateActionChildTable } from "../../../components/climate-action-child-table/climate-action-child-table";
import { ClimateActionDescription } from "../../../components/climate-action-description";
import { useCurrentClimateActionContext } from "../../../hooks/use-current-climate-action-context";

export const ClimateActionDetailTabPage: FC = () => {
  const { currentWorkspace } = useCurrentWorkspaceContext();
  const { currentClimateAction } = useCurrentClimateActionContext();

  return (
    <main className="relative place-items-stretch overflow-auto">
      <ClimateActionDescription
        workspace={currentWorkspace}
        climateAction={currentClimateAction}
        show={{ title: false, description: true }}
      />
      <ClimateActionChildTable workspace={currentWorkspace} climateAction={currentClimateAction} />
      <hr className="mx-3 py-3" />
    </main>
  );
};
